<script setup>
import CiSerp from '@/components/CiSerp/CiSerp.vue';

definePageMeta({
  layout: 'default',
  middleware: ['location-translations-redirect'],
});
</script>

<template>
  <CiSerp />
</template>
